import { getAuthApolloClient } from '../graphql/ApolloClient';
import {
  GET_MEDIA_APPROVAL_BY_ID,
  type GetMediaApprovalByIdData,
  type GetMediaApprovalByIdVariables,
  type MediaApprovalMaType,
} from '../graphql/query/moderate.queries';
import type { UserNotification } from '../../types/notification';

export type ApprovalModalView = 'reel-review' | 'reel-details' | 'video-review' | 'video-details';

export const isVideoMediaType = (maType?: string): boolean => {
  if (!maType) { return false; }
  const normalized = maType.toUpperCase();
  return normalized === 'VIDEOS' || normalized === 'VIDEO';
};

export const getApprovalModalView = (mode: 'review' | 'details', maType?: string): ApprovalModalView => {
  if (isVideoMediaType(maType)) {
    return mode === 'review' ? 'video-review' : 'video-details';
  }
  return mode === 'review' ? 'reel-review' : 'reel-details';
};

/** Best-effort type from notification copy when nInfo has no maType. */
export const inferMediaTypeFromMessage = (message: string): MediaApprovalMaType | undefined => {
  const lower = message.toLowerCase();
  if (/\breels?\b/.test(lower)) { return 'REELS'; }
  if (/\bvideos?\b/.test(lower)) { return 'VIDEOS'; }
  return undefined;
};

export const fetchApprovalMediaType = async (maId: string): Promise<MediaApprovalMaType | undefined> => {
  const client = getAuthApolloClient();
  const { data } = await client.query<GetMediaApprovalByIdData, GetMediaApprovalByIdVariables>({
    query: GET_MEDIA_APPROVAL_BY_ID,
    variables: { maId },
    fetchPolicy: 'cache-first',
  });
  return data?.mediaApprovalByMaId?.maType;
};

export const resolveApprovalMediaType = async (notification: UserNotification, maId: string): Promise<MediaApprovalMaType | undefined> => {
  if (notification.mediaType) { return notification.mediaType; }
  const fromMessage = inferMediaTypeFromMessage(notification.message);
  if (fromMessage) { return fromMessage; }
  return fetchApprovalMediaType(maId);
};
